export enum AttendanceStatus {
  Pending = "Pending",
  CheckedIn = "CheckedIn",
  NoShow = "NoShow"
}

export default AttendanceStatus;
